import { all } from "redux-saga/effects"

import loginSaga from "Containers/Login/saga"
import newPasswordSaga from "Containers/NewPassword/saga"
import administrationSaga from "Containers/Administration/saga"
import businessInformationsSaga from "Containers/BusinessInformations/saga"
import colorPalettesSaga from "Containers/ColorPalettes/saga"
import adminConsoleSaga from "Containers/ConsoleAdminContainer/saga"
import homePageConfigSaga from "Containers/HomePage/saga"
import caseSaga from "Containers/MSF/Cases/saga"
import mainInformationsSaga from "Containers/MainInformations/saga"
import notificationsSaga from "Containers/Notifications/saga"
import pageSaga from "Containers/Page/saga"
import pageListSaga from "Containers/PageList/saga"
import widgetsSaga from "Containers/Widget/saga"

export default function* rootSaga() {
  yield all([
    loginSaga(),
    colorPalettesSaga(),
    newPasswordSaga(),
    businessInformationsSaga(),
    pageListSaga(),
    pageSaga(),
    widgetsSaga(),
    mainInformationsSaga(),
    adminConsoleSaga(),
    notificationsSaga(),
    homePageConfigSaga(),
    caseSaga(),
    administrationSaga(),
  ])
}
